const ALLOWED_PROTOCOLS = new Set(['http:', 'https:', 'tel:', 'mailto:'])

/**
 * Safely opens a URL in a new tab with `noopener,noreferrer`.
 * Blocks javascript: and data: URIs. Allows same-origin, whitelisted protocols, and trusted CDN domains.
 */
export function safeOpen(url: string | undefined | null): void {
  if (!url) return

  // Allow relative paths (same-origin by definition)
  if (url.startsWith('/') && !url.startsWith('//')) {
    window.open(url, '_blank', 'noopener,noreferrer')
    return
  }

  try {
    const parsed = new URL(url, window.location.origin)

    if (!ALLOWED_PROTOCOLS.has(parsed.protocol)) return

    // tel: and mailto: are safe — open without target
    if (parsed.protocol === 'tel:' || parsed.protocol === 'mailto:') {
      window.open(url)
      return
    }

    window.open(url, '_blank', 'noopener,noreferrer')
  } catch {
    // Invalid URL — do nothing
  }
}
